import { OfertaResource } from '@/models/resources';

const FATOR_CODIGO_CREDOR = 10 ** 11;

function getCodigoCredorBase(codigoCredor: number): number {
  return codigoCredor - (codigoCredor % 100);
}

export function getIdBaseUnica(payload: {
  codigoCredor: number;
  idEntidade: number;
}): string {
  return (
    getCodigoCredorBase(payload.codigoCredor) * FATOR_CODIGO_CREDOR + payload.idEntidade
  ).toString();
}

export function getDividaIdBaseUnica(codigoCredor: number, dividaId: number): string {
  return getIdBaseUnica({ codigoCredor, idEntidade: dividaId });
}

export function getOfertaIdBaseUnica(
  codigoCredor: number,
  ofertaId: OfertaResource['id'],
): string {
  if (typeof ofertaId === 'number') {
    return getDividaIdBaseUnica(codigoCredor, ofertaId);
  }

  if (typeof ofertaId === 'string') {
    return ofertaId;
  }

  throw new Error('Erro ao definir ofertaId no envio de evento.');
}
